import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import '../../../Modal/styleModal.css';
import { loadFobImagesFromServer} from '../../../FileResources/FobFoto/ServiceUtilitiesFobFoto';

const DialogFobFoto = ({open, onClose, id}) => {
 
  const [uploadMessage, setUploadMessage] = useState('');
  const [serverImageUrls, setServerImageUrls] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  // Открытие модального окна для изображения
  const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  // Закрытие модального окна
  const closeModal = () => {
    setSelectedImage(null);
  };

  // Загружать изображения при старте страницы
  useEffect(() => {
    loadFobImagesFromServer(id, setServerImageUrls, setUploadMessage);
  }, []); 
  
    return (
      <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md"> 
      <DialogContent>
        <div className='divFotoRes' style={{ width: '100%', height: '100%', paddingRight: '10px' }}>
          {serverImageUrls.length > 0 && (
            <div style={{ height: '100%' }}> 
              
              <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Файлы фоб</label>
              <br/>
              <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{id}</span> </label>
              <hr className='horizontalLineDialog'/>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr', 
                  gap: '10px', 
                   width: '100%',
                  height: '100%',
                  overflowY: 'auto', 
                }}
              >
            
                {serverImageUrls.map((image, index) => (
                   <div key={index} style={{ position: 'relative', marginTop: '10px' }}>
                    <img
                      src={image.url}
                      alt={`Изображение с сервера ${index}`}
                      style={{ maxWidth: '100%', height: 'auto', cursor: 'pointer' }}
                      onClick={() => handleImageClick(image.url)}
                    />
                     <a
                        href={image.url}
                        download
                        onClick={(e) => e.stopPropagation()}
                        className="download-button-foto"
                      >
                        Скачать
                      </a>
                  </div>
                ))}
              </div>
            </div>
          )}
          {uploadMessage && <p>{uploadMessage}</p>}
      
      {/* Модальное окно для просмотра изображения */}
      {selectedImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={closeModal} 
        >
          <img
            src={selectedImage}
            alt="Полноразмерное изображение"
            style={{ maxWidth: '90%', maxHeight: '90%' }}
          />
        </div>
      )}
    </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogFobFoto;